import { Injectable, signal } from '@angular/core'
import { HttpErrorResponse } from '@angular/common/http'

export type Toast = Readonly<{
  message: string,
  type: 'success' | 'error'
  delayMultiplier?: number // 1 - standard delay, 2 - 2x, etc
}>

export const getMessageFromError = (error: unknown, defaultMessage?: string) => {
  const detail = (error as HttpErrorResponse).error?.detail
  if (Array.isArray(detail)) {
    return detail.join(' ')
  } else {
    const { message, detail } = error as { message?: string, detail?: string }
    return detail ?? message ?? defaultMessage ?? 'An unknown error occurred'
  }
}

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  toasts = signal<Toast[]>([])

  show(toast: Toast) {
    this.toasts.update((toasts) => [...toasts, toast])
  }

  remove(toast: Toast) {
    this.toasts.update(toasts => toasts.filter(t => !(t.message === toast.message && t.type === t.type)))
  }

  showError(error: unknown, defaultMessage?: string, status = -1) {
    const message = getMessageFromError(error, defaultMessage)
    // eslint-disable-next-line no-console
    console.error({ message, status })
    this.show({ type: 'error', message })
  }
}
